import * as Yup from "yup";

export const DURATION_PRESETS = [15, 20, 30, 45, 60];
export const MAX_AVAILABILITY_RULE_WINDOWS_PER_WEEK = 50;

export const DAYS_OF_WEEK = [
  { value: "MONDAY", name: "Monday" },
  { value: "TUESDAY", name: "Tuesday" },
  { value: "WEDNESDAY", name: "Wednesday" },
  { value: "THURSDAY", name: "Thursday" },
  { value: "FRIDAY", name: "Friday" },
  { value: "SATURDAY", name: "Saturday" },
  { value: "SUNDAY", name: "Sunday" },
];

export const AVAILABILITY_MODES = [
  { value: "regular", name: "Regular" },
  { value: "on_call", name: "On call" },
  { value: "flexible", name: "Flexible" },
];

export const BLOCK_REASON_CODES = [
  { value: "LUNCH", name: "Lunch" },
  { value: "MEETING", name: "Meeting" },
  { value: "BREAK", name: "Break" },
  { value: "TRAINING", name: "Training" },
  { value: "DOCUMENTATION", name: "Documentation" },
  { value: "ADMINISTRATIVE", name: "Administrative" },
  { value: "OTHER", name: "Other" },
];

export const ACTIVE_FILTER_OPTIONS = [
  { value: "true", name: "Active" },
  { value: "false", name: "Inactive" },
  { value: "all", name: "All" },
];

export const SCHEDULE_STATUS_OPTIONS = [
  { value: "active", name: "Active" },
  { value: "cancelled", name: "Cancelled" },
];

export const APPOINTMENT_STATUS_LABELS = {
  proposed: "Pending",
  booked: "Accepted",
  fulfilled: "Completed",
  cancelled: "Rejected",
  no_show: "No show",
};

export const APPOINTMENT_STATUS_COLORS = {
  proposed: "#D1D100",
  booked: "#06b155",
  fulfilled: "#9e9e9e",
  cancelled: "#7f1734",
  no_show: "#6d4c41",
};

export const CATEGORY_COLORS = ["#1976d2", "#00897b", "#7b1fa2", "#ef6c00", "#3949ab", "#00838f", "#c2185b"];

export const serviceCategorySchema = Yup.object({
  organizationRef: Yup.string().required("Required field"),
  code: Yup.string().trim().required("Required field"),
  name: Yup.string().trim().required("Required field"),
  durationMinutes: Yup.number()
    .typeError("Required field")
    .integer("Must be a whole number")
    .min(1, "Duration must be 1–1440")
    .max(1440, "Duration must be 1–1440")
    .required("Required field"),
  bookingIncrementMinutes: Yup.number()
    .typeError("Required field")
    .integer("Must be a whole number")
    .min(1, "Increment must be 1–1440")
    .max(1440, "Increment must be 1–1440")
    .required("Required field")
    .test("divisible", "Duration must be divisible by increment", function (increment) {
      const duration = Number(this.parent.durationMinutes);
      if (!duration || !increment) return true;
      return duration % increment === 0;
    }),
});

export function categoryColor(id, index = 0) {
  if (!id) return CATEGORY_COLORS[index % CATEGORY_COLORS.length];
  let hash = 0;
  for (let i = 0; i < id.length; i += 1) {
    hash = id.charCodeAt(i) + ((hash << 5) - hash);
  }
  return CATEGORY_COLORS[Math.abs(hash) % CATEGORY_COLORS.length];
}
